import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { MultiselectAll, TitleSecondary } from '../../components';

import {
  emailOptions,
  pushNotificationOptions,
  smsOptions,
} from './client.marketing.data';

import styles from './clients.module.scss';

const isEqual = (arr1, arr2) =>
  arr1.length === arr2.length &&
  arr1
    .slice()
    .sort()
    .every((v, i) => v === arr2.slice().sort()[i]);

const ClientMarketing = ({
  communication_settings,
  toggleCommunicationSettings,
}) => {
  const [communicationSettings, setCommunicationSettings] = useState(
    communication_settings
  );

  useEffect(() => {
    if (!isEqual(communicationSettings, communication_settings)) {
      toggleCommunicationSettings(communicationSettings);
    }
  }, [communicationSettings]);

  return (
    <div className={styles.clientMarketingContainer}>
      <div className={styles.clientMarketingContainerHeader}>
        <TitleSecondary>Marketingas</TitleSecondary>
      </div>
      <div className={styles.clientMarketingNotificationsSettings}>
        <div className={styles.option}>
          <span className={styles.optionLabel}>Push Notifications</span>
          <div className={styles.list}>
            <MultiselectAll
              customId="push"
              showAll={false}
              array={pushNotificationOptions}
              type="object"
              valueType="number"
              state={communicationSettings}
              setState={setCommunicationSettings}
            />
          </div>
        </div>
        <div className={styles.option}>
          <span className={styles.optionLabel}>El. paštas</span>
          <div className={styles.list}>
            <MultiselectAll
              customId="email"
              showAll={false}
              array={emailOptions}
              type="object"
              valueType="number"
              state={communicationSettings}
              setState={setCommunicationSettings}
            />
          </div>
        </div>
        <div className={styles.option}>
          <span className={styles.optionLabel}>SMS</span>
          <div className={styles.list}>
            <MultiselectAll
              customId="sms"
              showAll={false}
              array={smsOptions}
              type="object"
              valueType="number"
              state={communicationSettings}
              setState={setCommunicationSettings}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

ClientMarketing.propTypes = {
  communication_settings: PropTypes.arrayOf(PropTypes.number).isRequired,
  toggleCommunicationSettings: PropTypes.func.isRequired,
};

export default connect()(ClientMarketing);
